export const BrandShippingData = ['Raymond', 'Pepe-Jeans', 'Celio', 'aime', 'aliff'];

export const ProductCategorySelect = [
  { value: 'Man_Shirt', label: "Man's Shirt" },
  { value: 'Man_Jeans', label: "Man's Jeans" },
  { value: 'Women_TShirt', label: 'Women T-shirt' },
  { value: 'Women_Skirt', label: 'Women Skirt' },
];

export const StateSelect = [
  { value: 'Washington', label: 'Washington' },
  { value: 'Minnesota', label: 'Minnesota' },
  { value: 'Utah', label: 'Utah' },
  { value: 'Idaho', label: 'Idaho' },
];

export const ColorSelect = [
  { value: 'Black', label: 'Black' },
  { value: 'Red', label: 'Red' },
  { value: 'Blue', label: 'Blue' },
  { value: 'White', label: 'White' },
];

export const BrandIconSelect = [
  { value: "Levi's", label: "Levi's" },
  { value: 'Hudson', label: 'Hudson' },
  { value: 'Denizen', label: 'Denizen' },
  { value: 'Spykar', label: 'Spykar' },
];
export const QualitySelect = [
  { value: 'Brand_New', label: 'Brand New' },
  { value: 'Second_Hand', label: 'Second Hand' },
  { value: 'Both_Quality', label: 'Both Quality' },
];
export const CardSelectType = [
  { value: 'Master', label: 'Master' },
  { value: 'Visa', label: 'Visa' },
];
